import React from "react";
import { Mic, MicOff } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";

export default function VoiceToggle({ enabled, setEnabled, supported, listening }) {
  const { t } = useLanguage();
  if (!supported) {
    return (
      <button
        type="button"
        className="vls-btn-secondary vls-voice-disabled"
        title={t("voiceNotSupported")}
        data-testid="voice-unsupported"
        disabled
      >
        <MicOff size={18} />
        <span className="vls-hide-sm">{t("voiceNotSupported")}</span>
      </button>
    );
  }
  return (
    <button
      type="button"
      onClick={() => setEnabled(!enabled)}
      className={`vls-btn-secondary vls-voice-btn ${
        enabled ? "vls-voice-on" : ""
      } ${listening ? "vls-voice-listening" : ""}`}
      data-testid="voice-toggle"
      aria-pressed={enabled}
    >
      {enabled ? <Mic size={18} /> : <MicOff size={18} />}
      <span className="vls-hide-sm">
        {enabled ? (listening ? t("listening") : t("voiceOn")) : t("voiceOn")}
      </span>
    </button>
  );
}
